<template>
<div id="regi">
<div id="join_wrap" class="join_layer" v-bind:style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%'} ">
    <div class="join-container">
        <div class="join-head">
        <div class="join-text"> <span>회원가입</span> </div>
        </div>
        <div class="join_box">
            <div class="join-body">
                <form id="user_register" action="./action/user_register.php" method="POST">
                    <input type="hidden" name="kind" value="">
                    <input type="text" v-model="user_name" name="reg_user_name" ref='user_name' v-on:focus='inputFocus("user_name")' placeholder="이름" autocomplete="off" class="keyboardInput" id="keyboardInputInitiator1">
                    <input type="text" v-model="user_hp" ref='user_hp' v-on:focus='inputFocus("user_hp")' class="input-touch" full_length="13" name="reg_user_hp" placeholder="휴대폰번호">
                    <input type="password"  v-model="password" ref='password' v-on:focus='inputFocus("password")' class="input-touch" full_length="4" name="reg_user_password" placeholder="비밀번호">
                    <input type="password" v-model="password_chk" ref='password_chk' v-on:focus='inputFocus("password_chk")' class="input-touch" full_length="4" name="reg_user_password2" placeholder="비밀번호확인">
                    <input type="text" v-model="parents_hp" ref='parents_hp' class="input-touch" v-on:focus='inputFocus("parents_hp")' full_length="13" name="reg_user_hp2" placeholder="부모님 휴대폰번호(선택사항)">
                    <div class="join-content">
                        <input type="checkbox" v-model="agree_yn" class="checks" id="agrre_yn" name="agrre_yn">
                        <label for="agrre_yn">개인정보취급방침동의</label>
                    </div>
                </form>
            </div>
            <div class="join-footer">
                <input type="button" class="join-cancel"  @click="close_regi" value="취소">
                <input type="button" class="join-register"  @click="go_register" value="회원가입">
            </div>
            <virtual-keyboard v-if="current_focus.type=='KEYBOARD'" v-bind:parent_key_str="user_name" v-on:keyClick="keyInput"></virtual-keyboard>
            <num-pad2 v-if="current_focus.type!='KEYBOARD'" v-bind:parent_key_str="parent_key_str" v-bind:key_type_str="current_focus.type" v-on:numClick="numPadInput"></num-pad2>
        </div>
        </div>
    </div>
</div>
</template>

<script>
const FOCUS_TYPE = {
    USER_NAME: {name:'user_name', type: 'KEYBOARD'},
    USER_HP: {name:'user_hp', type: 'PHONE'},
    PASS: {name:'password', type: 'PASSWORD'},
    PASS_CHK: {name:'password_chk', type: 'PASSWORD'},
    PARENTS_HP: {name:'parents_hp', type: 'PHONE'},
}
// import keyboard from "../../javascript/web_keyboard2";

import common from '@/javascript/common.js'
import virtualKeyboard from '../components/virtual-keyboard';
import numPad2 from '../components/num-pad2';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';

import vue from 'vue';
vue.component('virtual-keyboard', virtualKeyboard);
vue.component('num-pad2', numPad2);

export default {
    data: function () {
        return {
            del_password: '',
            step: 0,
            //req info
            user_name: '',
            password: '',
            password_chk: '',
            user_hp: '',
            parents_hp: '',
            agree_yn: '',
            current_focus: FOCUS_TYPE.USER_NAME,
            parent_key_str: '',
            store_bg_image: ''
        }
    },
    props: [
        // 'step',
    ],
    methods: {
        keyInput(keyStr) {
            this.user_name = keyStr;
        },
        inputFocus(type) {
            const focusObjectList = Object.values(FOCUS_TYPE);
            focusObjectList.forEach(
                (element) => {
                    if( element.name==type ) this.current_focus = element;
            });

            this.parent_key_str = this[this.current_focus.name];
        },
        numPadInput(numberStr, overMaxLength) {

            // num-pad에 넘겨줄 값 변경.
            this.parent_key_str = numberStr;

            if( this.current_focus===FOCUS_TYPE.USER_NAME ) {
                // user_hp
                this.user_name = numberStr;
                // set focus
                if( overMaxLength ) this.$refs.user_hp.focus();
                else this.$refs.user_name.focus();

            }else if( this.current_focus===FOCUS_TYPE.USER_HP ) {
                // user_hp
                this.user_hp = numberStr;

                // set focus
                if( overMaxLength ) this.$refs.password.focus();
                else this.$refs.user_hp.focus();
            } else if( this.current_focus===FOCUS_TYPE.PASS ) {
                // user_hp
                this.password = numberStr;

                // set focus
                if( overMaxLength ) this.$refs.password_chk.focus();
                else this.$refs.password.focus();
            } else if( this.current_focus===FOCUS_TYPE.PASS_CHK ) {
                // user_hp
                this.password_chk = numberStr;

                // set focus
                if( overMaxLength ) this.$refs.parents_hp.focus();
                else this.$refs.password_chk.focus();
            } else if( this.current_focus===FOCUS_TYPE.PARENTS_HP ) {
                // user_hp
                this.parents_hp = numberStr;
                // set focus
                if( !overMaxLength ) this.$refs.parents_hp.focus();
                // else this.current_focus = null;
            }
        },
        close_regi() {
            var router = this.$router;
            router.push('/start') // 이동 위치를 입력
        },
        go_register() {
            var agree_p = 0;
            // var store_id = localStorage.getItem('store_id');
            var store_id = this.$store.getters['getStoreId'];
            if (this.password != this.password_chk) {
                // alert('비밀번호 불일치');
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `비밀번호가 일치하지 않습니다.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);

                return;
            }
            if (this.user_name.length == 0) {
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `이름을 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                // alert('입력란 공백 체크');
                return;
            }else if(this.user_hp.length == 0){
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `휴대폰번호를 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                // alert('입력란 공백 체크');
                return;
            }else if(this.password.length == 0){
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `비밀번호를 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                // alert('입력란 공백 체크');
                return;
            }else if(this.password_chk.length == 0){
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `비밀번호 확인란을 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                // alert('입력란 공백 체크');
                return;
            }
            // else if(this.parents_hp.length == 0){
            //     const alert_param = {
            //     code: this.$store.getters['get_popup_code'].POPUP_ALERT,
            //     message: `부모님 휴대폰번호를 입력해주세요.`,
            //     router: '',
            //     };
            //     this.$store.commit('set_popup_type', alert_param);
            //     // alert('입력란 공백 체크');
            //     return;
            // }

            if (!this.agree_yn) {
                // alert('개인정보 동의란 체크');
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `개인정보취급방침란 을 확인해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            } else {
                agree_p = 1;
            }

            // 휴대전화 번호형식 체크
            var rgEx = /[01](0|1|6|7|8|9)[-](\d{4}|\d{3})[-]\d{4}$/g;
            var rgEx_sec = /[01](0|1|6|7|8|9)[-](\d{4}|\d{3})[-]\d{4}$/g;
            var chkFlg_my_num = rgEx.test(this.user_hp);

            if(!chkFlg_my_num){
                const alert_param = {
                       code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                       message: `휴대폰번호를 확인해주세요.`,
                       router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }
            if(this.parents_hp.length > 0){
                var chkFlg_paren_num = rgEx_sec.test(this.parents_hp);
                if(!chkFlg_paren_num){
                    const alert_param = {
                           code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                           message: `부모님 휴대폰번호를 확인해주세요.`,
                           router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }
            }


            var self = this;
            const type = config.REQ_MEMBER_USER_INSERT;
            const data = {
                data: {
                    'name': this.user_name,
                    'password': this.password,
                    'user_hp': this.user_hp,
                    'parents_hp': this.parents_hp,
                    'agree_yn': agree_p
                }

            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(function (response) {
                if(response.result){
                    const alert_param = {
                        code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `회원가입이 완료되었습니다.`,
                        router: '',
                    };

                    self.$store.commit('set_Item_register_info', {
                        id:self.user_hp,
                        pass:self.password,
                        flag:true
                    });
                    self.$store.commit('set_popup_type', alert_param);
                    // self.$router.push('/login') // 이동 위치를 입력
                }else{
                    const alert_param = {
                        code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `이미 사용중인 휴대폰 번호입니다`,
                        router: '',
                    };
                    self.$store.commit('set_popup_type', alert_param);
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        }

    },
    mounted() {

        this.$refs.user_name.focus();

        this.$nextTick(function () {
            common.con_test('func_test');

        });

        this.store_bg_image = this.$store.getters['get_store_bg_img_url'];
    },

}
</script>



// WEBPACK FOOTER //
// src/components/page/Register.vue